'use client';

import { Spinner } from '@/components/ui/primitives';

export interface FullPageLoaderProps {
  /** Optional message to display below the spinner */
  message?: string;
  /** Background color variant */
  variant?: 'primary' | 'secondary' | 'tertiary';
}

/**
 * Full-page loading state with spinner and optional message
 * Use for page transitions, authentication, data loading, etc.
 */
export function FullPageLoader({ 
  message, 
  variant = 'primary' 
}: FullPageLoaderProps) {
  const bgClass = {
    primary: 'bg-bg-primary',
    secondary: 'bg-bg-secondary',
    tertiary: 'bg-bg-tertiary',
  }[variant];

  return (
    <div className={`flex min-h-screen w-full items-center justify-center ${bgClass}`}>
      <div className="flex flex-col items-center gap-4">
        <Spinner size="md" variant="default" />
        {message && (
          <p className="text-sm text-text-secondary animate-pulse">{message}</p>
        )}
      </div>
    </div>
  );
}
